import { Controller } from 'stimulus';
import loadSlick from '../helpers/loadSlick';

class BlockSlider extends Controller {
  connect() {
    this.$element = $(this.element);
    this.$slider = $(this.sliderTarget);
    this.$prev = this.$element.find('.js-block-slider-prev');
    this.$next = this.$element.find('.js-block-slider-next');
    this.$arrows = this.$element.find('.js-block-slider-arrows');

    loadSlick().then(() => {
      this.create();
    });
  }

  disconnect() {
    this.$slider.slick('unslick');
  }

  create() {
    this.$prev.on('click', () => {
      this.$slider.slick('slickPrev');
    });

    this.$next.on('click', () => {
      this.$slider.slick('slickNext');
    });

    const config = {
      rows: 0,
      arrows: false,
      mobileFirst: true,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      cssEase: 'cubic-bezier(.455, .03, .515, .955)',
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
      ],
    };

    this.$slider.slick(config);
  }
}

BlockSlider.targets = [
  'slider',
];

export default BlockSlider;
